import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertService } from '../components/app-alert';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private _baseUrl: string = '/api/';

  constructor(
    private httpClient: HttpClient,
    private alertService: AlertService
  ) { }

  public set baseUrl(url: string) {
    this._baseUrl = url;
  }

  private getUrl(url: string): string {
    return this._baseUrl + url;
  }

  public get<T>(url: string = '', 
                next?: (value: T) => void, 
                params?: {[param: string]: string | string[];}
  ): Subscription {
    return this.httpClient.get(this.getUrl(url), {params: params})
      .subscribe(
        next,
        (error) => {
          this.alertService.error(error.message);
        }
      );
  }

  public put<T>(url: string = '', 
                data: any, 
                next?: (value: T) => void, 
                params?: {[param: string]: string | string[];}
  ): Subscription {
    return this.httpClient.put(this.getUrl(url), data, {params: params})
      .subscribe(
        next,
        (error) => {
          this.alertService.error(error.message);
        }
      );
  }

  public patch<T>(url: string = '', 
                  data: any, 
                  next?: (value: T) => void, 
                  params?: {[param: string]: string | string[];}
  ): Subscription {
    return this.httpClient.patch(this.getUrl(url), data, {params: params})
      .subscribe(
        next,
        (error) => {
          this.alertService.error(error.message);
        }
      );
  }

  public download(url: string = '', fileName: String): Subscription {
    return this.httpClient.get(this.getUrl(url), { responseType: 'blob' })
      .subscribe(data => this.downloadData(data, fileName));
  }

  private downloadData(data, fileName) {
    const url = window.URL.createObjectURL(data);
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  public upload(url: string, file: File, callBack: (event: any) => any): Subscription {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post(
      this.getUrl(url),
      formData,
      {
        // // NOTE: Because we are posting a Blob (File is a specialized Blob
        // // object) as the POST body, we have to include the Content-Type
        // // header. If we don't, the server will try to parse the body as
        // // plain text.
        // headers: {
        //   "Content-Type": file.type
        // },
        // params: {
        //   clientFilename: file.name,
        //   mimeType: file.type
        // },
        reportProgress: true,
        observe: 'events'
      }
    )
    .pipe(map(callBack))
    .subscribe();
  }
}